import React from 'react'

import { SessionsBanner } from '../SessionsBanner'
import { Camp as BaseCamp } from '../../types'

interface Camp extends BaseCamp {
  totalDurationDays?: number
  projectsOutputDescription?: string
}

export const CampPointers = ({ camp }: { camp: Camp }) => (
  <div className='uncontainer'>
    <SessionsBanner outputDescription={camp.projectsOutputDescription ?? ''} />
  </div>
)
